import React from 'react';

type Props = {
	placeholder: string;
	text: string;
	edit: (newText: string) => void;
	multiline?: true;
	autoFocus?: true;
};
type State = {};

class TextEditor extends React.Component<Props, State> {
	onInputChange = (evt: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		const { edit } = this.props;
		edit(evt.target.value);
	};

	render() {
		const { text, placeholder, multiline, autoFocus } = this.props;

		if (multiline) {
			return (
				<textarea
					placeholder={placeholder}
					value={text}
					onChange={this.onInputChange}
					style={{
						fontSize: '14px',
						fontFamily: 'sans-serif',
						width: '400px',
						height: '50px',
					}}
				/>
			);
		}

		return (
			<input
				autoFocus={autoFocus}
				placeholder={placeholder}
				value={text}
				onChange={this.onInputChange}
				style={{
					fontSize: '14px',
					fontFamily: 'sans-serif',
					width: '180px',
				}}
			/>
		);
	}
}

export default TextEditor;
